// 1_utils/scroll_to_element.js
// Exposed on window.NAT.utils so any .js file (2_components, 3_pages, …) can call
// it without an import:  window.NAT.utils.scrollToElement(myEl);
// Smooth-scrolls to the element, offset by the fixed #header height.

window.NAT = window.NAT || {};
window.NAT.utils = window.NAT.utils || {};

window.NAT.utils.scrollToElement = function (element) {
	const headerHeight = document.querySelector("#header").offsetHeight;
	window.scrollTo({
		top: element.getBoundingClientRect().top + window.pageYOffset - headerHeight,
		behavior: "smooth",
	});
};
